module.exports = __webpack_public_path__ + "4d6970e90bd59534ecb4847e232060c4.glb";